// Core
import {useCallback} from 'react';
import {
    Box,
    Text,
    Flex,
    Checkbox,
} from '@chakra-ui/react';


const PermissionList = ({newObject, setNewObject}) => {

    const handleNewKeyChange = useCallback((object) => {
        setNewObject((prev) => {
            const prevCapabilitiesGiveaways = prev.capabilitiesGiveaways;
            const updatedCapabilitiesGiveaways = prevCapabilitiesGiveaways.map(capability => {
                if (capability.key === object.key) {
                    return {...capability, status: !capability.status};
                } else {
                    return capability;
                }
            });
            return {
                ...prev,
                capabilitiesGiveaways: updatedCapabilitiesGiveaways,
            };
        });
    }, [setNewObject]);

    const items = newObject?.capabilitiesGiveaways || [];
    return (
        <>
            <Box>
                {items.map((row) => (
                    <Flex key={row.key} w="100%" justifyContent="space-between" pt="16px">
                        <Box w="100%" pb="16px">
                            <Checkbox
                                w="100%"
                                isChecked={row.status}
                                onChange={() => handleNewKeyChange(row)}
                                colorScheme="blue"
                            >
                                <Text variant="title" w="100%">
                                    {row.title}
                                </Text>
                            </Checkbox>

                            <Text pl="32px" as="span" color="#9fabcb" variant="text-sm">
                                API - {row.key}
                            </Text>
                        </Box>
                    </Flex>
                ))}
            </Box>
        </>
    );
};

export default PermissionList;